import styled from 'styled-components';

// graph related styles
export const GraphMain = styled.div`
  margin-top: 16px;
  border-radius: 6px;
  background: #fff;
  padding: 16px;
`;

export const GraphMainTitle = styled.div`
  font-size: 14px;
  color: #1f1f1f;
  font-weight: bold;
`;

export const GraphSubTitle = styled.div`
  font-size: 14px;
  color: #1f1f1f;
  font-weight: lighter;
  padding: 2px 0 16px;
`;

export const GraphCompContainer = styled.div`
  position: relative;
`;

export const EchartGraphDom = styled.div`
  width: 100%;
  border-top: 1px solid #f0f0f0;
  background: transparent;
  z-index: 1;
`;

export const GraphTitleContainer = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
`;

export const GraphMetricCategoryContainer = styled.div`
  flex: 1;
  border-right: 1px solid #f0f0f0;
  padding: 8px 16px;

  &:last-child {
    border: 0;
  }
`;

export const GraphMetricCategoryTitle = styled.span`
  font-size: 12px;
  color: #0046ff;
  font-weight: bold;
  margin-left: 8px;
  vertical-align: middle;
`;

export const GraphMetricCategoryImg = styled.img`
  width: 26px;
  vertical-align: middle;
`;

export const MetricSectionSplitter = styled.div`
  font-size: 12px;
  color: #1f1f1f;
  font-weight: bold;
  background: #f5f5f5;
  padding: 8px;
`;

export const MetricsContainer = styled.div`
  display: flex;
`;

export const MetricScope = styled.div`
  flex: 1;
  border-right: 1px solid #f0f0f0;
  padding: 8px 16px;

  &:last-child {
    border: 0;
  }
`;

export const MetricLine = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: lighter;
  color: #1f1f1f;
  margin-bottom: 4px;
`;

export const MetricFilterLine = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #1f1f1f;
  margin-bottom: 2px;
`;

export const MetricSplitter = styled.div`
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
`;
